import { Stock } from '@telialt/models/src/EshopModel';

export const getLocalizedStockShipmentDate = (stock: Stock) => {
    return stock?.nextDeliveryDate
        ? new Date(stock.nextDeliveryDate).toLocaleDateString('lt-LT', {
              month: 'long',
              day: 'numeric',
          })
        : undefined;
};
